import { OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import { useAsync } from "react-use";
import type { AsyncState } from "react-use/lib/useAsyncFn";
import { useUnpausedForkStatus } from "../../context";

export default function useSDK(): AsyncState<OnchainSDK> {
  const { marketConfigurators, rpcUrl, addressProvider, network } =
    useUnpausedForkStatus();

  return useAsync(async () => {
    if (!marketConfigurators?.length) {
      throw new Error("No market configurators found");
    }

    const sdk = new OnchainSDK(network, {
      rpcURLs: [rpcUrl],
      timeout: 480_000,
    });
    await sdk.attach({
      addressProvider,
      marketConfigurators,
      ignoreUpdateablePrices: true,
    });
    return sdk;
  }, [addressProvider, marketConfigurators, rpcUrl, network]);
}
